import { styled } from '@olxeu-jobs/ui';

const COUNTER_NAME = 'stepper' as const;
const COUNTER_SIZE_EM = '2.6em' as const;

export const List = styled('ol', ({ $theme }) => ({
  position: 'relative',
  padding: 0,
  margin: 0,
  listStyle: 'none',
  counterReset: COUNTER_NAME,
  display: 'flex',
  flexDirection: 'column',
  gap: $theme.space[16],
}));

export const ListItem = styled('li', ({ $theme }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  counterIncrement: COUNTER_NAME,
  fontSize: $theme.fontSizes[14],
  '::before': {
    zIndex: 1,
    display: 'flex',
    flex: '0 0 auto',
    alignSelf: 'flex-start',
    width: COUNTER_SIZE_EM,
    aspectRatio: '1',
    marginRight: $theme.space[8],
    alignItems: 'center',
    justifyContent: 'center',
    content: `counter(${COUNTER_NAME})`,
    backgroundColor: $theme.colors['background-brand-secondary'],
    borderRadius: '50%',
    border: `0.3em solid ${$theme.colors['background-brand-secondary-light']}`,
  },
  '::after': {
    position: 'absolute',
    display: 'block',
    content: '""',
    width: '2px',
    height: `calc(100% + 2 * ${$theme.space[16]})`, // adding row gap
    top: '50%',
    left: `calc(${COUNTER_SIZE_EM} / 2)`,
    transform: 'translate(-50%, -50%)',
    backgroundColor: $theme.colors['background-brand-secondary'],
  },
  ':first-of-type': {
    '::after': {
      height: '100%',
      top: 0,
      transform: 'translateX(-50%)',
    },
  },
  ':last-of-type': {
    '::after': {
      height: '100%',
      bottom: '100%',
      transform: 'translate(-50%, -100%)',
    },
  },
  ':only-of-type': {
    '::after': {
      display: 'none',
    },
  },
}));

export const ListItemContent = styled('div', () => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  justifyContent: 'center',
}));
